import React from "react";
import { Navbar } from "@allxsmith/bestax-bulma";
import {Link} from "react-router-dom";

function TransactionsNav({transactionType, setMenuActive}) {
  const transMapping = {income: "Income", expenses: "Expenses"}


  return (
      <Navbar.DropdownMenu>
        <Navbar.Item
              onClick={() => {
                setMenuActive(false);
              }}
            >
            <Link to={"/po"}>
                Workshop Expenses
            </Link>
        </Navbar.Item>
        <Navbar.Item
            onClick={() => {
                setMenuActive(false);
            }}
        >
            <Link to={"/fixedexpense"}>
                Fixed Expenses
            </Link>
        </Navbar.Item>
        {transactionType === "expenses" ?
        <Navbar.Item
            onClick={() => {
                setMenuActive(false);
            }}
        >
            <Link to={"/vanpartsincome"}>Van Parts Income</Link>
            <Link to={"/vanpartsexpenses"}>
                Van Parts Expenses
            </Link>
        </Navbar.Item> : null}
        <Navbar.Item
            onClick={() => {
                setMenuActive(false);
            }}
        >
            <Link to={`/${transactionType}`}>
                All {transMapping[transactionType]}
            </Link>
        </Navbar.Item>
      </Navbar.DropdownMenu>
  );
}

export default TransactionsNav;
